<template>
    <div :class="`DshCoordinates ycFormItem control-${mode}`">
        <div
            :class="{
                'DshCoordinates-wrap': true,
                'DshCoordinates-readonly': $isReadonly(canEdit, propsObj),
                'DshCoordinates-disabled': $isDisabled(canEdit, propsObj)
            }"
            @click="clickOpenModal"
        >
            <div
                class="DshCoordinates-text "
                v-if="curLnglat.length"
            >
                <span class="dsh-ellipsis dsh-padding-left10 dsh-padding-right10">{{ curVal.name }}</span>
                <Icon
                    class="dsh-margin-right10"
                    @click.stop="clickDelete"
                    v-if="finalCanEdit"
                    type="md-close"
                />
            </div>
            <span v-else>点击获取当前位置</span>
        </div>

        <Modal
            class="DshCoordinates-modal clearFlex-modal"
            v-model="showModal"
            title="选择位置"
            :footer-hide="true"
            :styles="modalStyles"
            @on-cancel="clickCancel"
        >
            <div slot="header">
                <Row
                    v-if="finalCanEdit"
                    type="flex"
                    justify="center"
                    align="bottom"
                >
                    <Col span="8">
                        <div>
                            <RadioGroup v-model="formData.kind">
                                <Radio label="keyword">按关键字搜索</Radio>
                                <Radio label="coordinate">按坐标搜索</Radio>
                            </RadioGroup>
                        </div>
                        <Row class="ms-margin-top10">
                            <Col span="16">
                                <Input
                                    v-model="formData.searchText"
                                    clearable
                                    placeholder="请输入..."
                                    @on-enter="clickSearch"
                                />
                                <span class="DshCoordinates-message">{{ searchMessage }}</span>
                            </Col>
                            <Col span="8">&nbsp;
                                <Button type="primary" @click="clickSearch">搜索</Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col span="8">
                        <div>坐标获取结果</div>
                        <Row class="ms-margin-top10">
                            <Col span="16">
                                <Input
                                    :value="curVal.name"
                                    :readonly="true"
                                    clearable
                                    @on-clear="clickClear"
                                    @click.native="clickMapFitView"
                                />
                            </Col>
                            <Col span="8">&nbsp;
                                <Button type="primary" @click="clickConfirm">确认</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row v-else>
                    <Col span="6" class="textRight dsh-padding-top10">当前位置：</Col>
                    <Col span="12">
                        <Input
                            :value="curVal.name"
                            :readonly="true"
                            @click.native="clickMapFitView"
                        />
                    </Col>
                    <Col span="6"></Col>
                </Row>
            </div>
            <transition>
                <div
                    v-if="showModal"
                    id="mapContain"
                    class="DshCoordinates-map"
                ></div>
            </transition>
            <div
                ref="divCoordinate"
                style="display: none; position:absolute;background:#fff;padding: 5px 10px"
            ></div>
        </Modal>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";
    const plotStrokeColor = "#4575EF";
    const plotFillColor = "#4575EF";

    let polygonOpt = {
        fillColor: plotFillColor,
        fillOpacity: 0.4,
        strokeColor: plotStrokeColor,
        strokeWeight: 5
    };
    let lineOpt = {
        strokeColor: plotStrokeColor,
        strokeWeight: 5
    };
    let markerOpt = {};

    export default {
        name: "DshCoordinates",
        mixins: [controlMixin],
        computed: {
            curVal: {
                get () {
                    return this.value[this.propsObj._key] || {
                        name: "",
                        lnglat: []
                    };
                },
                set (val) {
                    this.value[this.propsObj._key] = val;
                }
            },
            curLnglat: {
                get () {
                    return this.curVal.lnglat || [];
                },
                set (val) {
                    this.curVal.lnglat = val;
                }
            },
            kind () {
                return this.propsObj._showType;
            }
        },
        data () {
            return {
                // 确认前的value
                cloneValue: {
                    name: "",
                    lnglat: []
                },
                showModal: false,
                modalStyles: {
                    height: document.body.clientHeight * 0.96 + "px",
                    width: document.body.clientWidth * 0.96 + "px",
                    top: "2%"
                },
                formData: {
                    kind: "keyword",
                    searchText: ""
                },
                // 地图相应控件
                map: null,
                placeSearch: null,
                mouseTool: null,
                // 标记点
                marker: null,
                // 标记图形
                plot: null,
                // 提示信息
                searchMessage: ""
            };
        },
        created () {
        },
        methods: {
            // 打开窗体
            clickOpenModal () {
                this.showModal = true;
                this.cloneValue = this.$deepCopy(this.curVal);
                this.getMap();
            },
            // 点击确认
            clickConfirm () {
                this.showModal = false;
                this.change();
            },
            // 点击取消
            clickCancel () {
                this.curVal = this.cloneValue;
            },
            // 点击删除
            clickDelete () {
                this.curVal = {
                    name: "",
                    lnglat: []
                };
                this.$emit("change", []);
            },
            // 清除已选内容
            clickClear () {
                this.curVal = {
                    name: "",
                    lnglat: []
                }; // 清除当前标记
                this.handleRmoveMarker("default"); // 清除地图内标记
                this.handleOpenDraw(); // 打开绘图功能
            },
            // 点击搜索
            clickSearch () {
                if (!this.formData.searchText) {
                    this.searchMessage = "请输入搜索内容！";
                    return;
                }
                if (this.formData.kind === "coordinate") {
                    let lnglat = this.formData.searchText.split(",");
                    let lng = Number(lnglat[0]);
                    let lat = Number(lnglat[1]);
                    if (isNaN(lng) || isNaN(lat) || lng < -180 || lng > 180 || lat < -90 || lat > 90) {
                        this.searchMessage = "请输入正确的经纬度坐标！";
                    } else {
                        lnglat = new AMap.LngLat(lng, lat);
                        this.handleAddMarker([lnglat.lng, lnglat.lat], true, "default");
                    }
                } else {
                    this.placeSearch.search(this.formData.searchText, this.handlePlaceSearchCallback);
                }
            },
            // 地图自适应点
            clickMapFitView (view = this.plot) {
                this.map.setFitView(view);
            },
            getMap () {
                this.$nextTick(() => {
                    let divCoordinate = this.$refs.divCoordinate;
                    this.map = new AMap.Map("mapContain", {
                        zoom: 12
                    });

                    // 滑动显示坐标点
                    this.map.on("mouseover", function (e) {
                        divCoordinate.style.display = "block";
                    });
                    this.map.on("mousemove", function (e) {
                        divCoordinate.innerHTML = e.lnglat.toString();
                        divCoordinate.style.top = (e.pixel.y + 120) + "px";
                        divCoordinate.style.left = (e.pixel.x + 6) + "px";
                    });
                    this.map.on("mouseout", function (e) {
                        divCoordinate.style.display = "none";
                    });

                    // 集成插件
                    AMap.plugin(["AMap.PlaceSearch", "AMap.Scale", "AMap.ToolBar", "AMap.MouseTool"], this.handlePluginCallback);

                });
            },
            handlePluginCallback () {
                // 构造地点查询类
                this.placeSearch = new AMap.PlaceSearch();
                this.placeSearch.on("complete", this.handlePlaceSearchCallback);
                this.placeSearch.on("error", this.handlePlaceSearchCallback);

                // 加载集成工具
                this.map.addControl(new AMap.Scale());
                this.map.addControl(new AMap.ToolBar());

                // 监听draw事件可获取画好的覆盖物
                this.mouseTool = new AMap.MouseTool(this.map);
                this.mouseTool.on("draw", this.handleMouseToolCallback);

                // 设置默认坐标
                if (this.curLnglat.length) {
                    this.handleAddMarker(this.curLnglat, true);

                    if (this.kind === "multipleMarker") { // 多选打开绘图功能
                        this.finalCanEdit && this.handleOpenDraw();
                    }
                } else {
                    this.finalCanEdit && this.handleOpenDraw();
                }
            },
            handleMouseToolCallback (e) {
                if (e.obj.CLASS_NAME === "AMap.Marker") {
                    if (this.kind === "marker") {
                        this.plot = e.obj;
                        this.handleCloseDraw();
                    } else if (this.kind === "multipleMarker") {
                        if (this.plot) {
                            this.plot.push(e.obj);
                        } else {
                            this.plot = [e.obj];
                        }
                    }
                    // 设置坐标
                    let lnglat = e.obj.getPosition();
                    this.curLnglat.push([lnglat.lng, lnglat.lat]);
                    this.getRegeoCode();

                } else {
                    this.plot = e.obj;
                    // 设置坐标
                    this.curLnglat.push(...e.obj.getPath().map(lnglat => [lnglat.lng, lnglat.lat]));
                    this.getRegeoCode();
                    this.handleCloseDraw();
                }
            },
            handlePlaceSearchCallback (result) {
                if (result == "complete") {
                    return;
                }
                if (result.poiList && result.poiList.pois && result.poiList.pois.length) {
                    this.searchMessage = "";
                    let poi = result.poiList.pois[0];
                    this.handleAddMarker([poi.location.lng, poi.location.lat], true, "default");
                    this.marker.setTitle([poi.name, poi.address].join(poi.name && poi.address ? "\n" : ""));
                } else {
                    this.searchMessage = "没有搜索到结果！";
                }
            },
            // 打开绘图
            handleOpenDraw (type = this.kind) {
                switch (type) {
                case "marker": {
                    this.mouseTool.marker(markerOpt);
                    break;
                }
                case "multipleMarker": {
                    this.mouseTool.marker(markerOpt);
                    break;
                }
                case "polyline": {
                    this.mouseTool.polyline(lineOpt);
                    break;
                }
                case "polygon": {
                    this.mouseTool.polygon(polygonOpt);
                    break;
                }
                case "rectangle": {
                    this.mouseTool.rectangle(polygonOpt);
                    break;
                }
                case "circle": {
                    this.mouseTool.circle(polygonOpt);
                    break;
                }
                }
            },
            // 关闭绘图
            handleCloseDraw () {
                this.mouseTool.close();
            },
            // 添加图形
            handleAddMarker (location, centerView = true, type = this.kind) {
                location = JSON.parse(JSON.stringify(location));
                // 分类型添加
                if (["polygon", "rectangle", "circle"].includes(type)) {
                    // 图形类
                    this.plot = new AMap.Polygon({
                        ...polygonOpt,
                        path: location
                    });
                    this.map.add(this.plot);
                    centerView && this.map.setFitView(this.plot);// 视口自适应
                } else if (["default"].includes(type)) {
                    !this.marker && (this.marker = new AMap.Marker());
                    this.marker.setPosition(location);
                    this.marker.setMap(this.map);
                    if (this.kind === "marker") {
                        this.handleRmoveMarker();
                        this.handleCloseDraw();
                        this.curLnglat = [location];
                        this.getRegeoCode();
                    } else if (this.kind === "multipleMarker") {
                        this.curLnglat.push(location);
                        this.getRegeoCode();
                    }
                    centerView && this.map.setFitView(this.marker);
                } else if (["polyline"].includes(type)) {
                    this.plot = new AMap.Polyline({
                        ...polygonOpt,
                        path: location
                    });
                    this.map.add(this.plot);
                    centerView && this.map.setFitView(this.plot);// 视口自适应
                } else if (["multipleMarker", "marker"].includes(type)) {
                    this.plot = location.map(position => {
                        return new AMap.Marker({
                            map: this.map,
                            position: position
                        });
                    });
                    centerView && this.map.setFitView(this.plot);
                }
            },
            // 移除图形
            handleRmoveMarker (type = this.kind) {
                if (["default"].includes(type)) {
                    this.marker && this.map.remove(this.marker);
                    this.plot && this.map.remove(this.plot);
                } else {
                    this.plot && this.map.remove(this.plot);
                }
            },
            // 获取逆地理编码
            getRegeoCode (value, scuessFun) {
                let params = {
                    key: window.config.amapKey,
                    location: this.curLnglat[0],
                    radius: 1000,
                    extensions: "base",
                    batch: false,
                    roadlevel: 1
                };

                let paramStr = "";
                for (let attr in params) {
                    paramStr += attr + "=" + params[attr] + "&";
                }

                fetch("http://restapi.amap.com/v3/geocode/regeo?" + paramStr)
                    .then(res => res.json())
                    .then(response => {
                        if (response.status === "1" && response.regeocode) {
                            let address = response.regeocode.formatted_address;
                            this.curVal.name = address;
                        }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshCoordinates.vue